// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const ActionsheetIndicatorWrapper = createStyle({
  py: '$1',
  w: '$full',
  alignItems: 'center',
});
